import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CheckListOrderItems from "../workorderitems/workorderitemchecklist";

import Button from '@material-ui/core/Button';
import * as d3 from "d3";

const uuidv1 = require('uuid/v1');

export default function Signature(props) {
  let inputArea = React.createRef();
  const [fileID] = useState('file_' + uuidv1());
  const [currentOrderItems, setCurrentOrderItems] = useState([]);
  const [step, setStep] = useState(0);

  let handleClose = () => {
    props.handleClose();
  }

  let handleSave = () => {
    if (inputArea.current.outerHTML.length > 180) {
      let returnItems = [];
      currentOrderItems.forEach(item => {
        if (item.checked) {
          item.signature = inputArea.current.outerHTML
          returnItems.push(item);
        }
      });
      props.handleSave(returnItems);
      props.handleClose();
    }
  }

  useEffect(() => {
    if (document.documentElement) { document.documentElement.scrollTop = 0 }
    let orderItems = Object.assign([], props.orderItems);
    for (let i = orderItems.length - 1; i >= 0; i--) {
      if (orderItems[i].signature || !orderItems[i].setautograph) {
        orderItems.splice(i, 1);
      }
    }
    setCurrentOrderItems(orderItems)
  }, [props.orderItems])

  useEffect(() => {
    setTimeout(() => {
      signatureAction();
    }, 100);
  },[step]) //added []

  let updateOrderItem = (item) => {
    let orderItems = Object.assign([], currentOrderItems);
    orderItems.forEach(currentItem => {
      if (currentItem.guid === item.guid) {
        currentItem.checked = item.checked;
      }
    })
    setCurrentOrderItems(orderItems);
  }

  let signatureAction = () => {
    
    var line = d3.line()
      .curve(d3.curveBasis)
    var svg = d3.select("#svgElement" + fileID)
      .call(d3.drag()
        .container(function () { return this.parentNode; })
        .subject(function () { var p = [d3.event.x, d3.event.y]; return [p, p]; })
        .on("start", dragstarted));

    function dragstarted() {
    
      var d = d3.event.subject,
        active = svg.append("path").datum(d),
        x0 = d3.event.x,
        y0 = d3.event.y;

      d3.event.on("drag", function () {
        var x1 = d3.event.x,
          y1 = d3.event.y,
          dx = x1 - x0,
          dy = y1 - y0;

        if (dx * dx + dy * dy > 25) d.push([x0 = x1, y0 = y1]);
        else d[d.length - 1] = [x1, y1];
        active.attr("d", line);

      });
    }
  }


  return (
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
         {step === 0 && <DialogTitle id="form-dialog-title">Selecteer werk voor ondertekening</DialogTitle>}
         {step === 1 && <DialogTitle id="form-dialog-title">Ondertekening</DialogTitle>}
        <DialogContent >
          {currentOrderItems.length===0 
            && <p>Er zijn geen projecten aanwezig die u kunt ondertekenen.</p>}
          {step === 0
            && <CheckListOrderItems orderItems={currentOrderItems} onUpdate={updateOrderItem}></CheckListOrderItems>
          }
          {step === 1
            && <CheckListOrderItems orderItems={currentOrderItems} onUpdate={updateOrderItem} onlyChecked={true}></CheckListOrderItems>
          }
          {step === 1
            && 
            <React.Fragment>
            <div style={{ border: '1px solid silver', width: '400px', height: '250px',position:'relative' }} >
              <svg width="400px" height="250px" ref={inputArea} id={'svgElement' + fileID} className="signature" >
                <rect width="100%" height="100%" style={{ fill: 'none' }}></rect>
              </svg>
            </div>
            <div className="label">Na ondertekening is het niet meer mogelijk de gegevens te wijzigen.</div>
            </React.Fragment>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}  style={{float:'left'}} >Annuleren</Button>
          {step === 0 && <Button onClick={() => { setStep(1) }} variant="contained" color="primary">Naar ondertekening</Button>}
          {step === 1 && <Button onClick={handleSave} variant="contained" color="primary" >AKKOORD</Button>}

        </DialogActions>
      </Dialog>
  )
}
